export const ensureHttpsUrl = (value: string): string => {
	const trimmed = value.trim();
	if (!trimmed) return trimmed;
	return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
};
